import React, { useRef } from 'react'
import { Chart } from 'primereact/chart'
import { useTranslation } from 'react-i18next'
import { OverlayPanel } from 'primereact/overlaypanel'

import './StatisticsChart.scss'
import Legend from '../../chart-components/legend/Legend'

const EmployeeSummaryChart = (props: any) => {
  const { icon, number, label, color, legends, data } = props
  const { t } = useTranslation()
  const opProperties = useRef<OverlayPanel>(null)
  const showProperties = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!opProperties?.current?.state?.visible) {
      opProperties.current?.toggle(e, e.target)
    }
  }
  const hideProperties = (e: React.MouseEvent<HTMLDivElement>) => {
    opProperties?.current?.hide()
  }
  const chartData = {
    labels: [legends.firstLegend, legends.secondLegend],
    datasets: [
      data.firstValue.number !== 0 || data.secondValue.number !== 0
        ? {
            data: [data.firstValue.number, data.secondValue.number],
            backgroundColor: [color.firstColor, color.secondColor],
            hoverBackgroundColor: [color.firstColor, color.secondColor],
          }
        : {
            data: [100],
            backgroundColor: ['#cecece'],
            hoverBackgroundColor: ['#cecece'],
          },
    ],
  }
  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: data.firstValue.number !== 0 || data.secondValue.number !== 0 ? true : false,
      },
    },
  }
  return (
    <div className="statistic-container">
      <div className="statistics-total-container">
        <div className="statistic-icon">{icon}</div>
        <div className="statistic-total">
          <div className="d-flex align-items-center">
            <span className="number-total">{number}</span>

            {label === t('dashboard.system-defined-users') && (
              <div className="d-flex flex-row align-items-center">
                <div onMouseOver={(e) => showProperties(e)} onMouseLeave={(e) => hideProperties(e)}>
                  <i className="pi pi-info-circle info-icon mt-0 ms-2"></i>
                </div>
                <OverlayPanel ref={opProperties} id="overlay_panel" className="info-popup">
                  <div>
                    <div className="info-title">{t('overlaypanel-texts.active-user-header')}</div>

                    <ul className="info-text">
                      <li>{t('overlaypanel-texts.active-user-text1')}</li>
                      <li>{t('overlaypanel-texts.active-user-text2')}</li>
                    </ul>
                  </div>
                </OverlayPanel>
              </div>
            )}
          </div>

          <p className="label-text label-title">{label}</p>
        </div>
      </div>

      <div className="chart-container">
        <Chart type="doughnut" data={chartData} className="statistic-chart" options={options} />
        <div className="chart-legends">
          <Legend color={color.firstColor} value={data.firstValue} legend={legends.firstLegend} />
          <Legend color={color.secondColor} value={data.secondValue} legend={legends.secondLegend} />
        </div>
      </div>
    </div>
  )
}

export default EmployeeSummaryChart
